import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=9f980ffc&scoped=true"
import script from "./Finished.vue?vue&type=script&lang=ts"
export * from "./Finished.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f980ffc",
  null
  
)

export default component.exports